import * as firebase from "firebase/app";
import "firebase/messaging";
const initializedFirebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyCsAynXlbzuEHre9zxCMFvpHJEAYCJ_xwo",
  authDomain: "insa-app-f854c.firebaseapp.com",
  databaseURL: "https://insa-app-f854c.firebaseio.com",
  projectId: "insa-app-f854c",
  storageBucket: "insa-app-f854c.appspot.com",
  messagingSenderId: "806073629479",
  appId: "1:806073629479:web:946015cd913bae0943c702"
});
const messaging = initializedFirebaseApp.messaging();
messaging.usePublicVapidKey(
  // Project Settings => Cloud Messaging => Web Push certificates
  "BC1Kk3IPYtje94wNHRZWYGH4gU0wV1YojR-y6eIWAhMZ-NnlmosnM_1HPSFR5O7cYt4dox7sJRQxYs9mMFvXSEQ"
);
export { messaging };